// extracted by mini-css-extract-plugin
export default {"eledoPdfToolbar":"TopToolbar_eledoPdfToolbar__ZMQKk","toolbarGroup":"TopToolbar_toolbarGroup__dMksb"};